<template>
	<layout>
		<div class="row bg-white">
			
			<div class="col-12 col-md-4 p-0">
				<!-- <img :src="user.profile_image" class="w-100"> -->
				<div class="w-100" style="margin:auto;width:fit-content;height:fit-content;position: relative;">
					<img id='profile_image' style="background:white;width:100%" :src="user.profile_image" alt="">
					<a  @click="triggerFileChooser()" href="#" class="uploadImage">
						<i  class="fas fa-plus"></i>
						<b>Wijzig profielfoto</b>
					</a>

					<input @change="readFile($event)" type="file" id="dp" class="d-none" />
				</div>
				<div class="p-3" v-if="checkUserHasPermission('reset user password')">
					<h2>Mail nieuw wachtwoord:</h2>
					<button @click="resetPassword()" class="btn ml-auto btn-sm pl-5 pr-5" v-if="passwordResetButton">Reset</button>
					<div class="alert alert-success" role="alert" v-if="passwordResetError == 0">
						Wachtwoord reset uitgevoerd
					</div>
					<div class="alert alert-danger" role="alert" v-else-if="passwordResetError == 1">
						Wachtwoord reset mislukt
					</div>
				</div>
				<div class="p-3">
					<h2>Werkt in:</h2>
					<div v-if="checkUserHasPermission('edit user branches')">
						<div class="row" v-if="fieldsEditable">
							<div class="col-10">
								<select class="form-control" v-model="branch_id">
									<option>Voeg vestiging toe</option>
									<option v-for="(branch, index) in branches" :value="branch.id">{{ branch.title }}</option>
								</select>
							</div>
							<div class="col-2">
								<button @click="addBranchToUser()" class="btn">+</button>
							</div>
						</div>
					</div>
					<ul>
						<li v-for="(branch, index) in user.branches" :key="index">
							<a :href="'/branch/'+branch.id" v-if="!fieldsEditable">{{ branch.title }}</a>
							<div v-if="fieldsEditable" @click="removeBranchFromUser(branch.id)"><i class="fa fa-trash"></i> {{ branch.title }}</div>
						</li>
					</ul>
				</div>

				<div class="p-3">
					<h2>Heeft rollen:</h2>
					<div v-if="checkUserHasPermission('edit user roles')">
						<div class="row" v-if="fieldsEditable">
							<div class="col-10">
								<select class="form-control" v-model="role_id">
									<option>Voeg rol toe</option>
									<option v-for="(role, index) in roles" :value="role.id">{{ role.name }}</option>
								</select>
							</div>
							<div class="col-2">
								<button @click="addRoleToUser()" class="btn">+</button>
							</div>
						</div>
					</div>
					<ul>
						<li v-for="(role, index) in user.roles" :key="index">
							<a :href="'/role/'+role.id" v-if="!fieldsEditable">{{ role.name }}</a>
							<div v-if="fieldsEditable" @click="removeRoleFromUser(role.id)"><i class="fa fa-trash"></i> {{ role.name }}</div>
						</li>
					</ul>

					<div v-if="checkUserHasPermission('create user') && user.member_end">
						<h2>Verwijder:</h2>
						<a @click="removeUser"><i class="fa fa-trash"></i></a>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-8">
				<pagetitle>{{ user.firstname }} {{ user.lastname }}<span class="float-right" v-if="user.id == user_state.id || checkUserHasPermission('edit profile')"><i @click="edittable()" class="fa fa-edit"></i></span></pagetitle>
				<div v-if="edit">

				</div>
				<div v-else>
					<table class="table table-borderless">
						<tbody>
							<tr v-if="checkUserKey('password')">
								<td>{{ userKeysName['password'] }}</td>
								<td><input class="form-control" type="password" :disabled="!fieldsEditable"  v-model="user['password']"></td>
							</tr>
							<tr v-if="checkUserKey('password')">
								<td>{{ userKeysName['repassword'] }}</td>
								<td><input class="form-control" type="password" :disabled="!fieldsEditable"  v-model="user['repassword']"></td>
							</tr>
							<tr>
								<td></td>
								<td>
									<button @click="updateProfile()" v-if="fieldsEditable" class="btn btn-sm pl-5 pr-5">Opslaan</button>
								</td>
							</tr>

							<tr v-for="(v, k, i) in user" :key="i" v-if="checkUserKey(k) && k!='password'">
								<td>{{ userKeysName[k] }}</td>
								<td v-if="checkUserKeyEditable(k)">
									<input class="form-control" type="text" :disabled="!fieldsEditable"  v-model="user[k]" v-if="inputtype(k) == 'text'">
									<input class="form-control" type="date" :disabled="!fieldsEditable"  v-model="user[k]" v-if="inputtype(k) == 'date'">
									<span v-if="inputtype(k) == 'label'"> {{ user[k] }}</span>
								</td>
								<td v-else>
									{{ user[k] }}
								</td>
							</tr>
							<tr>
								<td></td>
								<td>
									<button @click="updateProfile()" v-if="fieldsEditable" class="btn btn-sm pl-5 pr-5">Opslaan</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		
		</div>
	</layout>
</template>

<script>
import layout from '../layout/layout.vue'
	export default {

	  	name: 'profile',
	  	props:{
			id:{
				required: true
			},
			edit:{
				required: false
			}
		},
	  	components:{
			layout,
		},
	  	data () {
			return {
				passwordResetError : null,
				passwordResetButton : true,
				fieldsEditable:false,
				user_state : this.$store.state.user,
				user : {},
				userKeys: ['last_login', 'password','firstname', 'lastname', 'address', 'zipcode', 'city', 'country', 'phone', 'mobile', 'website', 'function', 'date_of_birth', 'member_since', 'member_end', 'about_me', 'email'],
				userKeysName : {
					'last_login' : 'Laatste keer ingelogd',
					'password' : 'Wachtwoord',
					'repassword' : 'Wachtwoord Controle',
					'firstname' : 'Voornaam',
					'lastname' : 'Achternaam',
					'address' : 'Adres',
					'zipcode' : 'Postcode',
					'city' : 'Plaats',
					'country' : 'Land',
					'phone' : 'Telefoonnummer',
					'mobile' : 'Mobiel',
					'website' : 'Website',
					'function' : 'Functie',
					'profile_image' : 'Afbeelding',
					'date_of_birth' : 'Geboortedatum',
					'member_since' : 'Werkzaam sinds',
					'member_end' : 'Werkzaam tot',
					'about_me' : 'Over mij',
					'email' : 'Emailadres',
					'branches': 'Vestigingen',
				},
				branches:[],
				roles:[],
				branch_id:0,
				role_id:0,
			}
		},
		methods : {
			inputtype:function(key){
				switch(key){
					case 'date_of_birth':
					case 'member_since':
					case 'member_end':
							return 'date';
						break;
					case 'last_login':
							return 'label';	
						break;
					default:
							return 'text';
				}
			},
			edittable:function(){
				if(this.fieldsEditable==false){
					this.fieldsEditable=true;
				}else{
					this.fieldsEditable=false;
				}
			},
			checkUserKey : function(key){
				return this.userKeys.includes(key);
			},
			checkUserKeyEditable : function(key){
				switch(key){
					case 'last_login':
							return false;
						break;

					case 'member_end':
							return this.checkUserHasPermission('edit user roles');
						break;

					default:
						return true;
				}
			},
			triggerFileChooser(){
				document.getElementById('dp').click();
			},
			readFile(e){
				let file=e.target.files[0];
				
				if(!(file.type == 'image/jpeg' || file.type == 'image/jpg' || file.type == 'image/png')){
					alert("file format not supported");

					return false;
				}

				let filereader=new FileReader();
				filereader.onload=(result)=>{
					document.getElementById('profile_image').src=result.srcElement.result;

					setTimeout(()=>{
						if(!confirm("Do you want to save this image ? ")){
							document.getElementById('profile_image').src=user.profile_image;
							return false;
						}


						//send request to change dp
						let user=JSON.parse(localStorage.getItem('user'));
						let formdata=new FormData();
						formdata.append('image',file);
						formdata.append('user',user);
						
						this.$store.dispatch('post',{endpoint:this.$store.state.endpoint+'users/profile-image/'+user.id+'/?token='+this.$store.state.token, details:formdata}).
						
						then(data=>{
							alert('Profile updated');
						})
						.catch(error=>{
							console.log(error.request);
						});

					},500);

					
				}

				filereader.readAsDataURL(file);
			},
			updateProfile:function(){
				console.log(this.user);
				let user=this.user;

				if(this.user.hasOwnProperty('password')){
					if(this.user.password != this.user.repassword){
		                this.error=true;
		                alert("Wachtwoorden komen niet overeen.");
		                return false;
		            }
		            
		            let password=this.user.password;
		            if(password.length < 8){
		                this.error=true;
		                alert("Wachtwoord moet minimaal 8 karakters hebben.");
		                return false;
		            }
		            if(password.search(/[0-9]/) < 0){
		                this.error=true;
		                alert("Wachtwoord moet minimaal 1 getal (0-9) bevatten.");
		                return false;
		            }
		            if(password.search(/[A-Z]/) < 0){
		                this.error=true;
		                alert("Wachtwoord moet minimaal 1 hoofdletter (A-Z) bevatten.");
		                return false;
		            }
				}

				this.$store.dispatch('post',{endpoint:this.$store.state.endpoint+'users/'+user.id+'/update?token='+this.$store.state.token,details:user} ).
						then(data=>{
							// console.log(data);
							this.fieldsEditable=false;
							alert('Profiel bewerkt');
						})
						.catch(error=>{
							console.log(error.request);
						});
			},
			addBranchToUser:function(){
				let user=this.user;
				let branch_id=this.branch_id;
				this.$store.dispatch('post',{endpoint:this.$store.state.endpoint+'users/'+user.id+'/addbranch?token='+this.$store.state.token,details:{'branch_id':branch_id}} ).
				then(data=>{
					this.$store.dispatch("get",this.$store.state.endpoint+'users/'+ this.id+'?token='+this.$store.state.token)
				    .then(data=>{  
				        this.user = data.data.data;
				    }) 
				    .catch(error=>{
				        if(error.request.status == 401){
				            this.error=true;
				            this.error_msg="invalid login details";
				        }
				        // window.console.log(error.request.response);
				        
				    });
				})
				.catch(error=>{
					console.log(error.request);
				});
			},
			addRoleToUser:function(){
				let user=this.user;
				let role_id=this.role_id;
				this.$store.dispatch('post',{endpoint:this.$store.state.endpoint+'users/'+user.id+'/addrole?token='+this.$store.state.token,details:{'role_id':role_id}} ).
				then(data=>{
					this.$store.dispatch("get",this.$store.state.endpoint+'users/'+ this.id+'?token='+this.$store.state.token)
				    .then(data=>{  
				        this.user = data.data.data;
				    }) 
				    .catch(error=>{
				        if(error.request.status == 401){
				            this.error=true;
				            this.error_msg="invalid login details";
				        }
				        // window.console.log(error.request.response);
				        
				    });
				})
				.catch(error=>{
					console.log(error.request);
				});
			},

			removeBranchFromUser:function(branch_id){
				console.log('branch_id', branch_id);
				let user=this.user;

				this.$store.dispatch('delete',this.$store.state.endpoint+'users/'+user.id+'/branch_id/'+branch_id+'?token='+this.$store.state.token).
				then(data=>{
					this.$store.dispatch("get",this.$store.state.endpoint+'users/'+ this.id+'?token='+this.$store.state.token)
				    .then(data=>{  
				        this.user = data.data.data;
				    }) 
				    .catch(error=>{
				        if(error.request.status == 401){
				            this.error=true;
				            this.error_msg="invalid login details";
				        }
				        // window.console.log(error.request.response);
				        
				    });
				})
				.catch(error=>{
					console.log(error.request);
				});
			},
			removeRoleFromUser:function(role_id){
				let user=this.user;

				this.$store.dispatch('delete',this.$store.state.endpoint+'users/'+user.id+'/role_id/'+role_id+'?token='+this.$store.state.token).
				then(data=>{
					this.$store.dispatch("get",this.$store.state.endpoint+'users/'+ this.id+'?token='+this.$store.state.token)
				    .then(data=>{  
				        this.user = data.data.data;
				    }) 
				    .catch(error=>{
				        if(error.request.status == 401){
				            this.error=true;
				            this.error_msg="invalid login details";
				        }
				        // window.console.log(error.request.response);
				        
				    });
				})
				.catch(error=>{
					console.log(error.request);
				});
			},
			removeUser(){
				let user=this.user;
				this.$store.dispatch('delete',this.$store.state.endpoint+'users/'+user.id+'/delete?token='+this.$store.state.token).
				then(data=>{
			        alert('Gebruiker verwijderd');
			        window.location="/users";
				})
				.catch(error=>{
					console.log(error.request);
				});
			},
			resetPassword : function(){
				console.log(this.user);
				// REQUESTING BRANCH DATA
			    this.$store.dispatch("get", this.$store.state.endpoint+"users/"+this.user.id+'/resetpassword?token='+this.$store.state.token)
			    .then(data=>{  
			        window.console.log('data',data.data);
			        // todo
			        this.passwordResetError = data.data.error;
			        if(data.data.error == false){
			        	this.passwordResetButton = false;
			        }
			    }) 
			    .catch(error=>{
			    	// todo
			        this.passwordResetError = data.data.error;
			    });
			}
		},
		created(){
		    window.console.log(JSON.parse(localStorage.getItem('user')));

		    // REQUESTING BRANCH DATA
		    if(this.id){
			    this.$store.dispatch("get",this.$store.state.endpoint+'users/'+ this.id+'?token='+this.$store.state.token)
			    .then(data=>{  
			        this.user = data.data.data;
			    }) 
			    .catch(error=>{
			        if(error.request.status == 401){
			            this.error=true;
			            this.error_msg="invalid login details";
			        }
			        // window.console.log(error.request.response);
			        
			    });

			    
			    	// REQUESTING FOR ALL AVAILABLE BRANCHES
				    this.$store.dispatch("get",this.$store.state.endpoint+'branches?token='+this.$store.state.token)
				    .then(data=>{  
				        this.branches=data.data.data;
				        window.console.log('data',data); 
				       
				    }) 
				    .catch(error=>{
				        if(error.request.status == 401){
				            this.error=true;
				            this.error_msg="invalid login details";
				        }
				    });
			    
			    	// REQUESTING FOR ALL AVAILABLE ROLES
				    this.$store.dispatch("get",this.$store.state.endpoint+'roles?token='+this.$store.state.token)
				    .then(data=>{  
				        this.roles=data.data.data;
				        window.console.log('data',data.data.data);
				       
				    }) 
				    .catch(error=>{
				        if(error.request.status == 401){
				            this.error=true;
				            this.error_msg="invalid login details";
				        }
				    });
			    
		    }
		},

	}
</script>

<style lang="css" scoped>
.uploadImage{ 
		position: absolute;
		margin: auto;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100%;
		height: 100%;
		opacity: 0; 
		color: white !important;
		text-decoration: none !important;
		
	}
	.uploadImage:hover{
		background: #0000008a;
		opacity: 1;
	}
	.uploadImage i.fas{
		display: block; 
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		width: fit-content;
		height: fit-content;
		color: white;
	}
	.uploadImage b{
		display: block; 
		position: absolute;
		top: 15%;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		width: fit-content;
		height: fit-content;
		color: white;
	}
	.field{
		transition: all .2s linear;
		padding-left: 5px;
	}
	.field:disabled{
		border:none;
		
	}
</style>